/** 用户 API（对接 /system/user/*） */

import request from './request';
import type { LoginResult, UserInfoResult, User, PageResult, RoleOption } from '@bluplanet/shared';

export interface LoginParams {
  username: string;
  password: string;
}

export interface UserQuery {
  page?: number;
  pageSize?: number;
  username?: string;
}

/** 用户表单（新增/编辑共用；password 仅新增时传） */
export interface UserForm {
  id?: string;
  username: string;
  password?: string;
  realName?: string;
  email?: string;
  phone?: string;
  status?: number;
  roles?: string[]; // 角色编码集合（roleKey），后端 assignRoles 按 roleKey 处理
}

/** 登录：POST /system/user/login */
export function login(params: LoginParams) {
  return request<LoginResult>({ url: '/system/user/login', method: 'POST', data: params });
}

/** 获取当前用户信息（菜单/权限/角色）：GET /system/user/info */
export function getInfo() {
  return request<UserInfoResult>({ url: '/system/user/info', method: 'GET' });
}

/** 用户列表（分页）：GET /system/user/list */
export function listUsers(params: UserQuery) {
  return request<PageResult<User>>({ url: '/system/user/list', method: 'GET', params });
}

/** 用户详情：GET /system/user/{id} */
export function getUser(id: string) {
  return request<User>({ url: `/system/user/${id}`, method: 'GET' });
}

/** 新增用户：POST /system/user */
export function createUser(form: UserForm) {
  return request<boolean>({ url: '/system/user', method: 'POST', data: form });
}

/** 编辑用户：PUT /system/user */
export function updateUser(form: UserForm) {
  return request<boolean>({ url: '/system/user', method: 'PUT', data: form });
}

/** 删除用户（逻辑删除）：DELETE /system/user/{ids}（ids 逗号拼接） */
export function deleteUsers(ids: string[]) {
  return request<boolean>({ url: `/system/user/${ids.join(',')}`, method: 'DELETE' });
}

/** 重置密码：PUT /system/user/resetPassword */
export function resetPassword(userId: string, newPassword?: string) {
  return request<boolean>({
    url: '/system/user/resetPassword',
    method: 'PUT',
    data: { userId, newPassword },
  });
}

/** 角色下拉（全部，用于用户表单多选）：GET /system/role/list（不传分页返回全量） */
export function listRoleOptions() {
  return request<RoleOption[]>({ url: '/system/role/list', method: 'GET' });
}

/** 聚合对象：页面按 userApi.xxx 调用 */
export const userApi = {
  login,
  getInfo,
  listUsers,
  getUser,
  createUser,
  updateUser,
  deleteUsers,
  resetPassword,
  listRoleOptions,
};
